import { ApiPath } from 'enums';
import { Get, Post, Put } from 'utils';

export const getProducts = async ({ ...query }) => {
  const res = await Get(`${ApiPath.Product}`, query);
  return res.data;
};

export const createProduct = async ({ ...body }) => {
  const res = await Post(`${ApiPath.Product}`, body);
  return res.data;
};

export const updateProduct = async ({ productId, ...body }) => {
  const res = await Put(`${ApiPath.Product}/${productId}`, body);
  return res.data;
};
